<template>
    <div class="currency-select-modal">
        <BaseModal v-if="isOpen"
                   contentOverflow="unset"
                   padding="40px"
                   maxWidth="480px"
                   useClickOutsideClose
                   @close="handleClose">
            <template #content>
                <CurrencySearch :fiatCurrencies="props.fiatCurrencies"
                                :currentFiatCurrency="props.currentFiatCurrency"
                                :isConverter="true"
                                :changeCurrencyProp="props.changeCurrencyProp"
                                :changeCryptoCurrencyProp="props.changeCryptoCurrencyProp"/>
            </template>
        </BaseModal>
    </div>
</template>

<script setup lang="ts">
    import BaseModal from '@/js/components/BaseModal.vue';
    import { useModalActive } from '@/js/composables/useModalActive';
    import { useConverterModalStore } from '@/js/store/currency-converter/ConverterModalStore';
    import { FiatCurrency } from '@/js/cryptocurrencies/types/fiatCurrency';
    import CurrencySearch from '@/js/cryptocurrencies/converter/CurrencySearch.vue';

    const props = defineProps<{
        currentFiatCurrency: FiatCurrency,
        fiatCurrencies: FiatCurrency[],
        changeCurrencyProp?:(selectedCurrency) => void,
        changeCryptoCurrencyProp?: (selectedCryptoCurrency) => void,
        isOpen: boolean;
    }>();

    const modalStore = useConverterModalStore();

    const handleClose = () => {
        modalStore.setConverterCurrencyModal(false);
    };

    useModalActive();
</script>

<style lang="scss">
@use "@/sass/design-system/variables" as variables;
@use "@/sass/partials/z-index" as ZIndex;
@use "@/sass/partials/breakpoints" as breakpoints;

.base-modal {
    z-index: ZIndex.$increased-base-modal-z-index !important;

    &__overlay {
        background-color: rgba(variables.$brand950, 0.9) !important;
    }

    &__container {
        min-height: 460px !important;

        @media (max-width: breakpoints.$md-breakpoint-max-width) {
            padding: 46px 16px !important;
        }
    }

    &__close-button {
        top: 10px !important;

        @media (max-width: breakpoints.$md-breakpoint-max-width) {
            top: 3px !important;
        }
    }

    .close-button__image {
        font-size: 14px !important;
    }
}
</style>
